module.exports = __webpack_public_path__ + "img/active-News2.18be7d45.jpg";